// TODO: Put URL in configuration

const loginPageUrlProd = 'https://app.mytalentplug.com'
const loginPageUrlPprod = 'https://preprod-app.mytalentplug.com'
const loginPageUrlLocal = 'http://localhost:60149/'
const minRatingLimit = 0
const maxRatingLimit = 5

export { loginPageUrlProd, loginPageUrlPprod, loginPageUrlLocal, minRatingLimit, maxRatingLimit }
